import { useQuery } from "@tanstack/react-query";
import { listCategories, type Category } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

export default function Categories() {
  const { data, isLoading, error } = useQuery({
    queryKey: ["categories"],
    queryFn: () => listCategories({ limit: 100 }),
  });

  if (isLoading) {
    return <div className="text-gray-500">Loading categories...</div>;
  }

  if (error) {
    return <div className="text-red-500">Error loading categories</div>;
  }

  return (
    <div>
      <div className="mb-6 flex items-center justify-between">
        <h1 className="text-2xl font-bold">Categories</h1>
        <Button>
          <Plus className="mr-2 h-4 w-4" />
          Add Category
        </Button>
      </div>

      <div className="rounded-lg bg-white shadow-sm">
        <table className="w-full">
          <thead>
            <tr className="border-b bg-gray-50 text-left text-sm font-medium text-gray-500">
              <th className="px-6 py-3">Name</th>
              <th className="px-6 py-3">Slug</th>
              <th className="px-6 py-3">Products</th>
              <th className="px-6 py-3">Status</th>
              <th className="px-6 py-3">Sort Order</th>
              <th className="px-6 py-3">Actions</th>
            </tr>
          </thead>
          <tbody>
            {data?.items.length === 0 ? (
              <tr>
                <td colSpan={6} className="px-6 py-8 text-center text-gray-500">
                  No categories found. Create your first category to get started.
                </td>
              </tr>
            ) : (
              data?.items.map((category: Category) => (
                <tr key={category.id} className="border-b">
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-3">
                      {category.icon ? (
                        <span className="text-xl">{category.icon}</span>
                      ) : (
                        <div className="flex h-8 w-8 items-center justify-center rounded bg-gray-100 text-sm font-medium">
                          {category.name[0]}
                        </div>
                      )}
                      <span className="font-medium">{category.name}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4 text-gray-500">{category.slug}</td>
                  <td className="px-6 py-4 text-gray-500">
                    {category._count?.products ?? 0}
                  </td>
                  <td className="px-6 py-4">
                    <span
                      className={`rounded-full px-2 py-1 text-xs ${
                        category.active
                          ? "bg-green-100 text-green-800"
                          : "bg-gray-100 text-gray-800"
                      }`}
                    >
                      {category.active ? "Active" : "Inactive"}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-gray-500">{category.sortOrder}</td>
                  <td className="px-6 py-4">
                    <Button variant="ghost" size="sm">
                      Edit
                    </Button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
